module.exports = __webpack_public_path__ + "img/p1-pic.c1ef4412.jpg";